<script setup>
import { useBranding } from 'dashboard/unichat/composables/useBranding';
import { UNICHAT_VERSION } from 'dashboard/unichat/version';

defineProps({
  message: {
    type: String,
    required: true,
  },
});

const { logoUrl, logoInternalUrl, fetchBranding } = useBranding();
fetchBranding();
</script>

<template>
  <div class="flex flex-col items-center justify-center h-full relative">
    <!-- Logo UniChat -->
    <div class="flex flex-col items-center gap-4 mb-4">
      <img
        :src="logoInternalUrl || logoUrl"
        alt="UniChat"
        style="width:80px;height:80px;object-fit:contain;filter:drop-shadow(0 4px 16px rgba(59,130,246,0.4));"
      />
      <span class="font-black tracking-tight leading-none select-none" style="font-size:2rem;color:white;">
        Uni<span style="background:linear-gradient(90deg,#3b82f6,#38bdf8);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;">Chat</span>
      </span>
    </div>

    <span class="text-sm text-n-slate-11 font-medium text-center">
      Mantendo você sempre conectado.
    </span>

    <!-- Versão no canto inferior direito -->
    <span class="absolute bottom-3 right-3 text-[10px] text-n-slate-9 select-none">
      {{ UNICHAT_VERSION }}
    </span>
  </div>
</template>
